import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Draft = new StatusEnumItem({
  id: '9c57143e-4007-4220-bfb0-925a44f9a418',
  name: 'Draft',
  description:
    'The Field Design Change is ready to be created, but not ready to advance through the FDC Tracker',
  priority: 0,
})
const PendingLevelConcurrences = new StatusEnumItem({
  id: '4eae3df1-6fc0-40bb-b1c1-45af76a580de',
  name: 'Pending Level Concurrences',
  description:
    'Concurrers accept or reject the Concurrence Level of the Field Design Change. Rejected Field Design Changes go back to Draft',
  priority: 1,
})
const PendingApprovals = new StatusEnumItem({
  id: '254585f2-4bd1-462b-8b04-dd85615fe1ff',
  name: 'Pending Approvals',
  description:
    'Approvers check off Approval Groups associated with the Field Design Change. Authorized Users may revert the Field Design Change back to Pending Level Concurrences',
  priority: 2,
})
const Closed = new StatusEnumItem({
  id: '57f82068-83d2-4b98-9e62-9c174f117a58',
  name: 'Closed',
  description:
    'The Field Design Change has fully advanced through the FDC Tracker workflow. Its associated SharePoint folder is locked from editing',
  priority: 3,
})
const Unlocked = new StatusEnumItem({
  id: 'c1fb06d0-f12a-4014-a230-4c7b04725000',
  name: 'Unlocked',
  description:
    'The Field Design Change is closed, but its associated SharePoint folder has been unlocked for editing',
  priority: 4,
})

export type FieldDesignChangeStatusItem =
  | typeof Draft
  | typeof PendingLevelConcurrences
  | typeof PendingApprovals
  | typeof Closed
  | typeof Unlocked

class FieldDesignChangeStatusEnum extends StatusEnum<
  'FieldDesignChangeStatus',
  FieldDesignChangeStatusItem,
  FieldDesignChangeStatusItem['name'],
  FieldDesignChangeStatusItem['id'],
  FieldDesignChangeStatusItem['priority']
> {
  readonly typename = 'FieldDesignChangeStatus'
  get values() {
    return [
      this.Draft,
      this.PendingLevelConcurrences,
      this.PendingApprovals,
      this.Closed,
      this.Unlocked,
    ]
  }
  readonly Draft = Draft
  readonly PendingLevelConcurrences = PendingLevelConcurrences
  readonly PendingApprovals = PendingApprovals
  readonly Closed = Closed
  readonly Unlocked = Unlocked
}

export const FieldDesignChangeStatus = new FieldDesignChangeStatusEnum()
